import { Box } from "@mui/system";
import { Fragment, useState } from "react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "../Image.jsx";
import { tagValues } from "../../../../../lib/tag-values";
const Gallery = ({ data, gallery }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [indexOfImage, setindexOfImage] = useState(0);
  const [swiper, setSwiper] = useState(null);
  const [showThumbnail, setshowThumbnail] = useState({});
  const slideTo = (index) => swiper?.slideTo(index);
  return (
    <div className="md:border md:p-5  border-dashed border-[#CBCBCB]">
      <div className="flex gap-4 ml-8">
        <img src="/images/icons/calender.svg" width={18} alt="calender" />
        <span className="text-sm">
          {new Date(data?.createdAt).toLocaleDateString()}
        </span>
        <img src="/images/icons/clock.svg" width={18} alt="clock " />
        <span className="text-sm">
          {String(new Date(data?.createdAt).getHours()).padStart(2, "0")} :{" "}
          {String(new Date(data?.createdAt).getMinutes()).padStart(2, "0")}
        </span>
        <img src="/images/icons/eye.svg" width={18} alt="eye " />
        <span className="text-sm">{data?.visits}</span>
      </div>
      <div className="">
        {" "}
        <Swiper
          /*  dir="rtl" */
          navigation={true}
          pagination={{
            clickable: true,
          }}
          loop={true}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Navigation, Thumbs]}
          /*    autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
        speed={400} */

          className="md:rounded-md overflow-hidden singleProduct  mt-5"
          onSwiper={setSwiper}
          onSlideChange={(e) => {
            setindexOfImage(e.activeIndex);
            setshowThumbnail({});
          }}
        >
          {gallery?.map((banner, index) => (
            <SwiperSlide
              key={index}
              className="md:rounded-md overflow-hidden  "
            >
              <div className="flex justify-center w-full">
                {" "}
                <div className="flex justify-center w-full p-5 md:w-[90%] bg-[#EBEBEB] rounded-md">
                  {" "}
                  <Image
                    id={banner?.galleryId}
                    className=" overflow-hidden  min-h-[300px] w-full rounded-lg"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="flex gap-3 mt-4 md:px-7">
        {gallery?.map((item, i) => (
          <Box
            sx={{
              position: "relative",
              width: "72px",
              height: "72px",
              cursor: "pointer",

              img: {
                borderRadius: "4px",
                border: "2px solid",
                borderColor: indexOfImage === i ? "blue" : "#cccccc",
              },
            }}
            key={i}
            onClick={() => {
              setindexOfImage(i);
              slideTo(i);
            }}
          >
            <Image
              style={{}}
              id={`${item.galleryId}`}
              alt="/"
              className={`w-[70px] h-[70px] `}
            />
          </Box>
        ))}
      </div>
      <div className="flex gap-3 mt-4 md:px-7">
        <img className="w-6 mr-4" src="/images/icons/tag.svg" alt="tag" />
        {tagValues(data?.tag).map((item, index) => (
          <Fragment key={index}>
            {" "}
            <div className="bg-[#EBEBEB] cursor-pointer text-xs py-1 px-2">
              {item}
            </div>
          </Fragment>
        ))}

    
      </div>
    </div>
  );
};

export default Gallery;
